import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {

  URL = (location.hostname === "localhost" ) ? "http://localhost/appintranet/frontend/src/assets/uploadImage/" :"https://www.app.johnsonmiller.co/assets/uploadImage/";

  constructor(
    private http: HttpClient
  ) { }

  uploadFile(formularioCambiarEstado){
    return this.http.post(`${this.URL}uploadUser.php`,JSON.stringify(formularioCambiarEstado))
  }

  public postFileImagen(imagenParaSubir: File,id_pedido,type){

		const formData = new FormData(); 
    formData.append('imagenPropia', imagenParaSubir, imagenParaSubir.name); 
    formData.append('id_pedido', id_pedido);
    formData.append('type', type);
		return this.http.post(`${this.URL}uploadImage.php`, formData);

	}
}
